import { render, staticRenderFns } from "./NavBarCompany.vue?vue&type=template&id=2d01680c&scoped=true&"
import script from "./NavBarCompany.vue?vue&type=script&lang=js&"
export * from "./NavBarCompany.vue?vue&type=script&lang=js&"
import style0 from "./NavBarCompany.vue?vue&type=style&index=0&id=2d01680c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01680c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBarMenu: require('/workspace/components/NavBarMenu.vue').default,UserAvatar: require('/workspace/components/UserAvatar.vue').default,SuperAdminCompanyModal: require('/workspace/components/SuperAdminCompanyModal/SuperAdminCompanyModal.vue').default})
